import React from "react";
import Utkarsh_Sri from "./Utkarsh_Sri.webp";
import "./blogs.css";

const Utkarsh = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src={Utkarsh_Sri}
            style={{ height: "315px", width: "90%" }}
            alt="Utkarsh"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Utkarsh Srivastava</h2>
            <small>Data Analyst at ICICI Bank</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col--md-12">
            <h3>Introduction </h3>
            <p>
              Hello everyone! I'm Utkarsh Srivastava (Y20) a recent B.Tech
              graduate from Civil Engineering department. I know most readers of
              this blog are going to go through this just around their placement
              season, so first of all, All the Best, Keep Calm and “chaap dena”.
              Also, those who are short of time, can skip the journey and read
              the placement tips at the last. My journey from a fresher at IIT
              Kanpur to a Data Analyst at ICICI Bank has been like a game of
              snakes and ladders. I got many ladders which instantly boosted my
              growth, along with a few snakes who brought me down or slowed me
              down too. Let's go through the various chapters of my campus life
              via placement perspective.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/1.jpg"
          alt="Utkarsh"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>THE ONLINE BUBBLE</h3>
            <p>
              Being a part of a special “Online” batch - Y20, I’d begin with the
              difference I observed. When students are at campus, they are aware
              of their surroundings, their wingies, their batchmates and the
              campus junta. They know what skills they are learning and what
              their aim is, but in an online semester, you know only what you
              are told. In my first semester, I was not very good at acads and I
              started with an average satti. I was learning new skills and
              making new friends but I still had no aim. To begin with, the
              first ladder I took was an unpaid internship at an EdTech startup
              ‘Unschool’ as a product manager. The term “unpaid” becomes
              important here as, we as IITians sometimes get an ego, which I
              also had at some phase, that I have cracked IIT and now I’ll
              directly start my internship at Google or Microsoft. The bitter
              truth is, even as a fresher, you need “experience” to get any
              internship or placement. It was then that I decided to get an
              unpaid internship, suppressing my ego. There I got my first ladder
              and the first bullet point of my resume.
            </p>

            <p>
              After this internship, I started living in the “bubble” that I am
              amongst the top achievers in my batch who has an internship in the
              first year. I was in the skies and wanted to become the best so I
              started stacking up PORs to get a stronger resume. I started with
              festivals, as they were the only thing I knew about IIT Kanpur
              before even coming here. I became a Junior Executive at Techkriti.
              This was the ladder that boosted my communication skills. I
              created a strong resume and soon my fresher year ended and the
              summers began but the bubble was still there. In the last years of
              my school time, coding was like a magnet for me. When I came to
              college, I got to know about CP (competitive programming). I began
              brushing up my skills in CP as soon as my first year ended. As
              summer 2021 started, I picked up 2 projects, IITK Coin and Intro
              to web development. Later on I did projects on computer vision and
              3D modelling too. IITK Coin was a very important project in my
              campus life which hopefully might get implemented in the campus
              soon. Personally, it is important for me as it has been a key
              point of discussion in most of my interviews be it internships or
              placements.
            </p>
            <p>
              With so many projects, PORs and an internship I created a good
              resume and got another internship in summer 2021 and this was my
              first paid internship as a Research Intern at ‘ARTPARK’ an IISc
              Bangalore incubated startup. This was the ladder of networking
              with which I stepped into the world of LinkedIn. I started
              connecting with more people and building up connections. I
              repeated my internship in Winter 2021 again to boost my experience
              in the Ops domain. By the beginning of my sophomore year, I had an
              aim to go into a tech career. I had a keen interest in web
              development so I started picking up PORs related to web
              development. I became Senior Executive Web at Techkriti and
              Udghosh and a secy at Web Division of SnT council.
            </p>
            <p>
              With so many ladders, it was the time for snakes to bite. The
              first snake bite was an emotional breakdown which slowed down my
              growth. All thanks to my friend circle, specially my roomie Ankur
              for standing by me and helping me keep strong through this phase.
              This was the Online to Offline transition phase and the time for
              the bubble to burst. As I got to know about the peers around me,
              their achievements, my confidence began to stumble as almost
              everyone was excelling in some or the other field. Few batchmates
              got internships at Unicorn startups like Uber and here I was with
              no brand name in my resume. This might sound as if it is not such
              a big issue but as my interests shifted, my resume became weaker.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>THE TECHKRITI LADDER</h3>
            <p>
              As the summers of 2022 began and my sophomore year was ending, I
              witnessed a shift in my interests. I was no longer enjoying coding
              and Web Dev as I used to, my PORs were no longer for skill
              development, instead they were just for filling up my resume. I
              started hunting for an internship again this summer. Somehow I
              landed up in a sales and BD role in a startup but this time there
              was a snake hidden in the disguise of the ladder. Not naming the
              company for obvious reasons, my third company’s environment was
              “toxic”. Having seven months of internship experience in the past,
              I knew how startup internships work but this was something totally
              different. I was working directly under the founder and we had
              daily update meets in which the toxic work culture was clearly
              visible. I took advice from a few of my friends and seniors
              regarding this and I quit the internship after completion of the
              first month itself. I would thank my senior Devansh, for giving me
              the confidence to stand up against what is wrong. This was a
              ladder which told me how important it is to choose the company
              wisely not just by the pay package but also the work culture.
              After so many snake bites, it was time for me to stand up and run
              again. I went through my achievements and set a new aim, this
              time, just a step. My new aim was to get in the core team of
              Techkriti, the Technical and entrepreneurial festival of IIT
              Kanpur. Now, it was not just a POR but a ladder to the top row of
              snakes and ladders. After a month of preparation and interviews, I
              finally became the marketing Head in Techkriti’23 core team. Along
              with that I also became a part of the HEC of Hall 3 as the Web
              InCharge.
            </p>
            <p>
              The position of Web InCharge of Hall 3 was a POR of transition for
              my interest from Tech to Product. It did involve my web
              development skills, but more than that it tested my management
              skills in my hostel. This was the phase when my interests and
              career aim transitioned and my new aim was to get a job in
              consulting or PM. As the Marketing Head of Techkriti, I got a huge
              boost in my communication and networking skills. I got in touch
              with founders, IAS officers, Government officials and CXOs of
              various established firms. I had personal meetings with them and I
              even got an offer to work with them from a few companies. The year
              passed by and I was on a growth curve through the Techkriti
              pillar, we successfully conducted a fully offline Techkriti in
              March 2023 after a gap of 4 years. My LinkedIn network was
              stronger than ever and so was my resume but still I had no intern
              in my hand. Let me tell you what went wrong when the intern season
              and Techkriti were running in parallel.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/2.jpg"
          alt="Utkarsh"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>INTERNSHIP SEASON 2022-23</h3>
            <p>
              The first realisation struck me when my resume did not get
              shortlisted in either of the two MBB firms which had come to hire
              summer interns despite having Techkriti core team POR although two
              of my other core team members got shortlisted. The internship
              season began with my cpi at 7. First days, then weeks, then months
              passed by giving tests and interviews. The closest I came was in
              the Limechat PM interview where I reached the final round but lost
              due to overconfidence and lack of preparation. Due to my
              negligence, my prep was weak for the interview rounds in the
              intern season and despite qualifying the test and resume round of
              interviews, I failed at the case studies and guesstimates. I gave
              around 7 interviews but my weak prep got me nowhere and this snake
              was a ladder of motivation in disguise for the placement season. I
              gave a try to a technical internship at Vizuara, a MIT USA
              incubated startup as a developer in September 2022 but did not
              enjoy it as much as I enjoyed my management work in Techkriti and
              Hall 3. I had to hunt for a job I would love to do for the
              summers. Months passed by and my junior undergrad year came to an
              end. Techkriti had wrapped up, I had left Hall 3 and my sem was
              over but still I had no intern in hand. It was time to use up my
              ladders to create a new one, a big one.
            </p>
            <p>
              I redesigned my resume, took advice from my seniors and compiled
              all my best achievements. I used the network and connections I
              built from Techkriti to reach out to HRs and founders on LinkedIn
              with lightning speed. I used cold messaging and emails. I was
              lucky enough to get replies from a lot of them and within 2 days I
              got my first offline internship at Flo Mattress, Mumbai. Flo is a
              bootstrapped D2C sleep solutions startup headquartered at Mumbai.
              During my two month internship, I worked on two key projects. My
              first month project was Ecommerce. I had no previous experience
              about how online marketplaces like Flipkart and Amazon work so I
              was again on a ladder of growth. I learnt a lot about how D2C
              brands work and the importance of marketplaces. My second month
              project was Influencer Marketing. I had previous experience of
              marketing through Techkriti, but this time I was on the opposite
              side of the table. This time, I had to give the money, not take
              it. I interacted with many influencers and learnt key points about
              how influencer marketing works.
            </p>
            <p>
              Amidst these ladder of growth and learnings, a snake bite
              happened. The result of my third year was out and it was a
              nightmare for me. It was not too low, but a number which was going
              to have a lot of repercussions in my placement season. A number
              which will remind me of a moment where I might have made a small
              mistake. A number, which I am going to regret throughout my life
              if I did not get placed. The CPI was 6.9!
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="/placement-postulates/blogs/Utkrash-Srivastava/3.jpg"
          alt="Utkarsh"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>THE 6.9 DILEMMA</h3>
            <p>
              After facing a lot of struggle in my intern season, I had decided
              to prep well for the interview rounds as I already had a strong
              resume and decent CPI of 7 but this new info, brought me into a
              dilemma. I was confused about what to do, whether to keep my focus
              on product where shortlisting starts from cpi 7 mostly, or should
              I shift back to Tech where I still might have a chance to achieve
              something. As my final year began, I started calculating worst
              case scenarios. I had heard placement is easier than internship
              season and given the fact I got shortlisted in around 7
              interviews, I was expecting 10 shortlists from the test rounds and
              at least 5 shortlists for interviews in the worst case. Things
              became worse as the wave of recession struck. Mass and fixed
              recruiters stepped back. The companies coming for placements had a
              great downfall in their numbers. Packages shrunk for few of them
              while few just gave PPOs and denied to come for placements. My
              chances of getting placed were getting lower and lower. PPTs of
              companies started and I started counting companies where I was
              directly getting rejected due to my cpi. Many important companies
              started their shortlisting from cpi 7 and I was losing them all
              because of a 0.1 or rather a 0.05. Many companies did not even
              allow students with CPI less than 7 to give the test. This was the
              most venomous snake that had ever bit me. At a time I felt I am at
              the wrong place, I do not deserve to be here but my peers kept me
              boosted.
            </p>
            <p>
              I chose to prepare for Web Dev, PM and consult. I restarted my CP
              practice, went through basic DSA, solved case studies, did
              guesstimates and learnt frameworks. Thanks to my peers like
              Abhiyanshu and Parth who helped me through my PM prep and Aditya
              who helped me for consult prep. This 6.9 dilemma had shook me to
              the core while the recession was like a strike on hot iron but I
              still stood strong and fought it all with the help of my peers.
              The shortlisting results started coming and my worst nightmares
              started turning into reality. I got no shortlist in any company.
              Months passed by and within 2 days it was going to be Day 1 of
              placement but still I had no shortlist in my hand. It was the
              midnight of November 30 when I finally got my first (and the last)
              shortlist of my placement season. Based upon the time it came, I
              was on the seventh sky. I had lost all hopes and was thinking of
              going for a dual degree when this miracle happened. The technical
              test of ICICI Bank Management trainee role had multiple sections
              with different topics like DSA, Query, Apti and LR. It was around
              3 hours with so many questions that the time feels less. After
              getting shortlisted from the test, I got shortlisted in the resume
              round too.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Dark Realities in Placement Processes:</h3>
            <p>
              The time had come for which most of us came to IIT Kanpur. It was
              the time for most of us, including me, to write a new chapter for
              our family. For many of us, it was a chance to rise in the
              economic table and support our family. With just one shortlist, I
              was very anxious about what will happen, but I had decided to give
              my best whatever happens. The next round was GD(Group Discussion)
              round which was scheduled for Day 3. The first 2 days of placement
              had 2 subphases each- 1.1, 1.2, 2.1 and 2.2. Day 1.1 of placement
              season phase 1 began. The students who were shortlisted in more
              than 10 companies, started getting placed and the waitlisted
              students got an opportunity. Interviews were happening every
              second but every second passed like an hour. When I wore the
              formals for the placement day, a strange anxiousness surrounded
              me. Every second I was hoping to get a chance for an interview but
              hours passed by with no hope. On Day 2, walkins started but to
              everyone’s surprise and utter disappointment, many companies were
              leaving without hiring any students. The hopes started to
              diminish. The students who were calculating their worst case
              interview dates, ran out of days. The number of students getting
              places hit a shocking low mark with only 50 students getting
              placed on an average in each subphase
            </p>
            <p>
              The first 2 days on the battleground passed as if we were
              witnessing a war which we are destined to lose. The coat felt
              heavier than anything I had ever worn. Sleep had vanished and the
              body stopped feeling the winter cold. Amidst these mishappenings,
              we were forced to keep sharpening our skills. I went through many
              guesstimates, case studies and puzzles available online on
              websites like GFG, Brainstellar etc. The night before the GD, I
              watched many youtube videos on how to be prepared for a great GD
              and how we should crack it. The next day was the most important
              day of my life, the D-Day for the only shortlist I had in my hand.
              I went through as many resources as I could and took guidance from
              many seniors and alumni.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/4.jpg"
          alt="Utkarsh"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>D-DAY</h3>
            <p>
              It was the 3rd of December, 2023. Sleep deprived and filled with
              nervousness, I was still trying to battle it all and pave my way.
              The GD round began early in the morning around 9 AM. All the
              shortlisted candidates were divided into groups of 7-8 each. The
              topic for my GD was around which type of vehicle is better:
              Electric, Diesel or Hybrid. It was the first GD of my life so I
              decided to go by what I learnt through YT videos and what the
              seniors told me. Few of the tips were:
              <br />
              Remember it is a group discussion, try to lead it but do not be
              the boss speaker.
              <br />
              Do not deviate from the topic or try to speak louder or fight with
              anyone.
              <br />
              Try to speak first and give as many inputs as you can and be the
              most prominent speaker in the room.
              <br />
              Sketch out keywords in your mind during the time you are reading
              the PS.
            </p>
            <p>
              I was expecting everyone would abide by similar rules but what
              happened was a totally different chaos. As soon as everyone got
              the PS, within 5 seconds one of the GD participants started
              speaking, while I was reading just the first few lines. I was
              clueless what to do. Suddenly, another participant interrupted him
              with a louder voice and a fight broke out in a verbal manner.
              Everyone was trying to dominate each other with a louder voice but
              I was sitting clueless what to do as I wasn’t prepared for this
              chaos. Thankfully, the interviewer interjected and gave the people
              who were silent, a chance to speak. I chose my words wisely as I
              had thought of some keywords by then. The facts I spoke were
              agreed upon by few of the other participants in the room which
              gave me a plus point of leadership. After the GD round I was very
              anxious about whether I will qualify for the interview round or
              not. Thoughts like “I should have also spoken up in the chaos”
              were crossing my mind. After a couple of hours since this storm
              was brewing in my mind, I got an info from my friends that I have
              been shortlisted for the interview round. When the official
              shortlist was out, I concluded that, for qualifying a GD, you
              don’t need to fight, just keep calm and put forth your points at
              the right time. The words should be chosen so wisely that even
              your competitors can’t deny them. If the GD is going far from the
              topic of discussion, you should interject and ask everyone to keep
              the discussion focused upon the topic and finally, speak with full
              “confidence”. If your voice lacks confidence, no one will ever
              support you and the interviewer will also not give any attention
              to it.
            </p>
            <p>
              Now, it was time for the final round. It was time for me to use
              all my ladders I've got in my life to build a ladder which no
              snake can ever climb. I utilised all my friends’ expertise and
              practised personal interviews as much as I could. I revised my
              resume more than 50 times and did mock interviews with friends who
              had expertise in tech and product both. The Management Trainee was
              a general role, no one knew what the questions could be. I studied
              everything about ICICI Bank as a company and its history. After
              waiting for a couple of hours more, it was time for my interview.
              As I entered the room, the setup was very basic. Two interviewers
              were sitting on the opposite side of the table with a laptop and a
              few official papers. They began with the most basic question:
              “Introduce yourself”. I was ready for this question since Day 0, I
              poured in all the snakes and ladders in my life within a 1 minute
              intro which made the panel impressed. It was a good start. The
              next question was very generic and I knew it as they had asked
              everyone the same question: “Describe a few projects of your life
              which had an impact”. Without much thinking, I was ready with my 2
              Key events: IITK Coin project and POR of Marketing Head of
              Techkriti'23.{" "}
            </p>
            <p>
              I described all about what challenges I faced in these projects
              and the smile on their face kept on widening. They
              cross-questioned a few technical and managerial things involved in
              these projects like the technology I used to make the IITK Coin
              API and how I dealt with the challenges I encountered to conduct
              Techkriti. It was then followed by a few HR questions about myself
              and family background and the interview lasted around half an
              hour. After the interview, I still remember the words of the
              interviewer: “ I loved your confidence!” accompanied by the action
              of extending his hand further for a handshake with me. That was
              the moment I knew, I had cracked it! I went out of the interview
              room and had to wait a couple of hours more and then the time for
              which I was waiting for months came. I got placed at ICICI Bank!
              My first corporate placement instead of a startup this time. As
              soon as I got to know about this news, my legs gave way and I sat
              wherever I was standing, I got emotional out of happiness and
              suddenly the heavy coat felt light like a feather. All the
              tension, anxiousness and negativity suddenly disappeared. The
              battlefield suddenly felt like a festival to me where my hard work
              was finally rewarded. Now, it was time for me to help those who
              stood by me in my hard times, my friends who were still fighting
              in the battlefield. The placement season phase 1 lasted around 7
              days properly with around 40% placements in the first phase after
              which the stats are unknown to me.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/5.jpg"
          alt="utkrash"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>CONCLUSION</h3>
            <p>
              This was my college life, nothing less than a game of snakes and
              ladders from the placement perspective. I would like to thank the
              Society of Civil Engineers for giving me a chance to present my
              placement journey through placement postulates and I will be more
              than happy if anyone gets inspired or gets any help by reading
              this blog. My college life has been full of surprises and
              challenges, the growth curve I had in my first two years came to a
              saturation point where I was feeling an all time low after not
              getting an internship through campus recruitment but I feel
              blessed that the peers and experienced I earned did not let me
              down and I was able to achieve what I am today.
            </p>

            <p>
              <b>TLDR; TIPS FOR PLACEMENTS:</b> <br />
              Never lose hope and confidence, these two are the most basic
              pillars of enthu during the placement season.
              <br />
              Keep revising your resume, and be aware of each and every word you
              have written in it.
              <br />
              For GD and interview rounds, you can go through the “D-Day”
              section
              <br />
              Build a strong network and connections so that you have backup
              offers in the worst case.
              <br />
              CPI is very important for getting shortlists in the placement
              season. Neveimport Utkarsh from './Utkarsh_srivastava'; r ignore
              your sixth sem CPI if you are sitting for placements after seventh
              sem.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Utkarsh;
